import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.trim";

// This has been replaced by the bem function.
// TODO: Replace all uses of `withModifiers` with `bem`
var withModifiers = function withModifiers(className) {
  return function (modifiers) {
    if (modifiers === void 0) {
      modifiers = [];
    }

    return (className + " " + modifiers.map(function (mod) {
      return className + "--" + mod;
    }).join(' ')).trim();
  };
};

export default withModifiers;